import { render } from "./Themedic.vue?vue&type=template&id=6bb7ecc2"
import script from "./Themedic.vue?vue&type=script&lang=js"
export * from "./Themedic.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__